import { Injectable } from '@angular/core';
import { Router, RouterStateSnapshot, ActivatedRouteSnapshot } from '@angular/router';
import { ContextFactory } from '@shared/factories/context/context.factory';
import { ApiServiceService } from '@shared/services/api-service/api-service.service';

@Injectable({
  providedIn: 'root'
})
export class RolesProductResolver  {
  constructor(private apiService: ApiServiceService,
    private router: Router,
    private context: ContextFactory) { }
  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    let productId: any = route.params['productId'];
    return this.apiService.get('productroles/product/'+productId+'/assignments')
      .then((data:any)=> {
        if(data?.length){
          return data;
        }else{
          this.router.navigate(['dashboard']);
        }
      })
  }
}
